var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-table',{ref:"table",attrs:{"url":_vm.url,"filter":_vm.InsOutsFilter,"fetchAfterCreate":true,"row-classes":{
    'table-warning': function (model) {
      return Boolean(model.disabled_at);
    },
    'table-danger': function (model) {
      return Boolean(model.deleted_at);
    }
  },"attributes":[
    {
      name: 'Moderator',
      type: 'UserNoEmailCell',
      attribute: 'user'
    },
    {
      attribute: 'total_performance',
      name: 'Verdiente Einheiten'
    },
    {
      attribute: 'ins',
      name: 'INs'
    },
    {
      attribute: 'outs',
      name: 'OUTs'
    }
  ]},on:{"table-fetched":_vm.updateTotal}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('table-filter',{attrs:{"filterComponents":[
        {
          id: 0,
          type: 'SelectFilter',
          label: 'Agentur',
          options: _vm.agencyOptions,
          attributes: 'agency_id'
        },
        {
          id: 1,
          type: 'InOutPerformanceFilter',
          label: 'Zeitraum'
        }
      ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.InsOutsFilter),callback:function ($$v) {_vm.InsOutsFilter=$$v},expression:"InsOutsFilter"}})],1),_vm._v(" "),(_vm.total)?_c('tr',{attrs:{"slot":"top"},slot:"top"},_vm._l((_vm.summaryFields),function(attribute,index){return _c('td',{key:'row-' + index},[_c('strong',[_vm._v("\n        "+_vm._s(index === 0 ? "Gesamt:" : _vm.total[attribute])+"\n      ")])])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }